import {Component, Input, OnInit} from "@angular/core";
import {PedidosService} from "../../services/pedidos.service";

@Component({
  selector: 'app-razao-cancelamento-keeta',
  templateUrl: './razao-cancelamento-keeta.component.html',
  styleUrls: ['./razao-cancelamento-keeta.component.scss']
})
export class RazaoCancelamentoKeetaComponent  implements OnInit {
  @Input() pedido: any;
  razaoCancelamento: any;
  razoesKeeta = [
    { code: 'INSUFFICIENT_DISHES', descricao: 'Falta de itens no cardápio / estoque esgotado'},
    { code: 'SUSPENSION_OF_BUSINESS', descricao: 'Restaurante fechado temporariamente'},
    { code: 'INSUFFICIENT_MANPOWER', descricao: 'Não há equipe suficiente para atender'},
    { code: 'OTHERS', descricao: 'OUTROS'}
  ];

  //  //code: "INSUFFICIENT_DISHES", "SUSPENSION_OF_BUSINESS", "INSUFFICIENT_MANPOWER","OTHERS"
  erroParaCancelar: string;

  constructor(protected pedidosService: PedidosService) { }

  ngOnInit(): void {  }


}
